export default "__VITE_ASSET__00a3a6d8__"